module.exports = __webpack_public_path__ + "img/sound.0128c6e4.gif";